// extracted by mini-css-extract-plugin
module.exports = {"section":"RelatedPosts_section__6AhRQ","title":"RelatedPosts_title__Nf4yj","grid":"RelatedPosts_grid__5E0VW"};
module.exports.__checksum = "ebab1399af58"
